import { useState } from "react"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import UserResetPasswordDialog from "@/v2-backoffice-client/user/resetPassword/UserResetPasswordDialog"

export type UserResetPasswordButtonProps = Omit<
  TooltipButtonProps,
  "content" | "onClick"
> & {
  userId: number
}

function UserResetPasswordButton(props: UserResetPasswordButtonProps) {
  const { userId, children, ...tooltipButtonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="xs"
        iconSrc="key"
        content="Reset this user's password."
        isSquare={!children}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        {...tooltipButtonProps}
      >
        {children}
      </TooltipButton>

      <UserResetPasswordDialog
        userId={userId}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default UserResetPasswordButton
